"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationService = void 0;
var oidc_client_1 = require("oidc-client");
var CommonService_decorator_1 = require("../../../core/decorators/CommonService.decorator");
var authHelper_1 = __importDefault(require("./authHelper"));
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService() {
        this.authHelper = authHelper_1.default;
        this.WebStorageStateStore = oidc_client_1.WebStorageStateStore;
    }
    AuthenticationService = __decorate([
        CommonService_decorator_1.CommonService('AuthenticationService')
    ], AuthenticationService);
    return AuthenticationService;
}());
exports.AuthenticationService = AuthenticationService;
//# sourceMappingURL=Authentication.service.js.map